import {immerable} from "immer";
import { HexMap } from "./HexMap";
import { Key } from "./Key";
import { Coordinates } from "../../Util/Math/Coordinates";
export interface NoteParams{
    noteIndex:number
    x:number
    y:number
    tonic:number
}
export interface KeyRelationship{
    keyIndex:number
    position:number
    label:string
    labelDisplay:boolean
    petalDisplay:boolean
}
export class Note{
    [immerable] = true
    keys:KeyRelationship[]
    params:NoteParams
    selectedState:number 
    halo:boolean = false   
    defined:boolean = true
    visible:boolean = true
    classNames:string[] = []
    primaryLabel:string | null = null
    secondaryLabel:string | null = null
    static PositionTypeOdd:number = 1
    static PositionTypeEven:number = 0
    static PositionTypeSeven:number = 7
    static SelectedState_Default:number = 0
    static SelectedState_Selected:number = 1
    static SelectedState_Hilited:number = 2
    constructor(params:NoteParams){
        this.params = params
        this.keys = []
        this.selectedState = Note.SelectedState_Default
    }
    getPositionType = () => {
        if(this.isSeven()){
            return Note.PositionTypeSeven
        }
        return( (this.isOdd()) ? Note.PositionTypeOdd : Note.PositionTypeEven )
    }
    isOdd = () => {
        const position:number = this.keys[0].position
        if(this.isSeven()) return false
        const oddness:boolean = ((position % 2) === 0)// zerobased means evens are odd positions: 1,3,5.
        return (oddness) 
    }
    isSeven = () => {
        const position:number = this.keys[0].position
        return (position === 6)
    }
    getCoordinates = () => {
        return new Coordinates(this.params.x, this.params.y)
    }
    static isSelected = (note:Note) =>  { return (note.selectedState === Note.SelectedState_Selected) }
    static isHilited = (note:Note) =>  { return (note.selectedState === Note.SelectedState_Hilited) }
    static isDefault = (note:Note) =>  { return (note.selectedState === Note.SelectedState_Default) }
    static hasAnotherOpenKey = (noteIndex:number, excludedKeyIndex:number, hexMap:HexMap) => {
        const note:Note = hexMap.notes[noteIndex]
        const hasOpenKey:boolean = (note.keys.find((keyRel:KeyRelationship)=>{
            const relkey:Key = hexMap.keys.flat()[keyRel.keyIndex]
            return (relkey.open && (relkey.params.keyIndex !== excludedKeyIndex))
        }) !== undefined)
        return hasOpenKey
    }
}